import { type Address, erc20Abi, maxUint256 } from "viem";

import { useContractStaticCall } from "../contracts";

import { useERC20Allowance } from "./useErc20Allowance";

interface Params {
  erc20: Address;
  spender: Address;
  amount: bigint;
  enabled?: boolean;
  chainId?: number;
}

export function useERC20Approve(params: Params) {
  const { erc20, spender, amount: _amount, enabled = true, chainId } = params;

  const amount = maxUint256;

  const allowanceQuery = useERC20Allowance({
    erc20Address: erc20,
    spenderAddress: spender,
    watch: true,
    enabled,
    chainId,
  });
  const { data: allowance } = allowanceQuery;
  const isApproved = allowance != undefined ? allowance >= _amount : undefined;

  const approvalQuery = useContractStaticCall({
    address: erc20,
    abi: erc20Abi,
    functionName: "approve",
    args: [spender, amount],
    chainId,
    query: { enabled: enabled && isApproved == false },
  });

  return { approvalQuery, allowanceQuery, isApproved };
}
